import React, { useEffect, useRef, useState } from "react";
import {
  Tag,
  Button,
  Col,
  Divider,
  Dropdown,
  Icon,
  Input,
  Menu,
  message,
  Modal,
  Row,
  Table,
  Typography,
  Upload,
  Switch,
  Select,
} from "antd";
import StoresTable from "views/stores-management/StoresTable";
import CohortsTable from "views/cohort-management/CohortsTable";
import ReportsTableColumns from "views/generated-reports/ReportsTableColumns";
const Roles = ["Admin", "Owner", "Pos-Member", "Developer"];
const { Text } = Typography;
const { Dragger } = Upload;
const { Option } = Select;

const StoreAddModal = (props) => {
  const { data } = props;
  return (
    <Row className="modal-row">
      <Row>
        <Text
          style={{
            fontWeight: "bold",
            color: "#181818",
            fontSize: "24px",
          }}
        >
          Stores Added
        </Text>
      </Row>
      <Row style={{ marginTop: "16px" }}>
        <div
          style={{
            width: "100%",
            height: "1px",
            background: "#E8E8E8",
          }}
        ></div>
      </Row>
      <Row style={{ marginTop: "32px" }}>
        <StoresTable data={data} viewOnly={true}></StoresTable>
      </Row>
    </Row>
  );
};
const CohortAddModal = (props) => {
  const { data } = props;
  data.cohorts = data.stores;
  return (
    <Row className="modal-row">
      <Row>
        <Text
          style={{
            fontWeight: "bold",
            color: "#181818",
            fontSize: "24px",
          }}
        >
          Cohort Added
        </Text>
      </Row>
      <Row style={{ marginTop: "16px" }}>
        <div
          style={{
            width: "100%",
            height: "1px",
            background: "#E8E8E8",
          }}
        ></div>
      </Row>
      <Row style={{ marginTop: "32px" }}>
        <CohortsTable data={data} viewOnly={true} {...props} />
        {/* <StoresTable data={data} viewOnly={true}></StoresTable> */}
      </Row>
    </Row>
  );
};

const ReportModal = (props) => {
  const { data } = props;
  data.cohorts = data.stores;
  return (
    <Row className="modal-row">
      <Row>
        <Text
          style={{
            fontWeight: "bold",
            color: "#181818",
            fontSize: "24px",
          }}
        >
          Reports Generated
        </Text>
      </Row>
      <Row style={{ marginTop: "16px" }}>
        <div
          style={{
            width: "100%",
            height: "1px",
            background: "#E8E8E8",
          }}
        ></div>
      </Row>
      <Row style={{ marginTop: "32px" }}>
        <ReportsTableColumns
          reportList={data.stores}
          viewOnly={true}
        ></ReportsTableColumns>
      </Row>
    </Row>
  );
};

const ActivityManagment = (props) => {
  const { data } = props;

  const [Status, setStatus] = useState(false);

  const [updateModal, setUpdateModal] = useState(false);
  const [DeleteModal, setDeleteModal] = useState(false);
  const [storeCreatedModal, setStoreCreatedModal] = useState(false);
  const columns = [
    {
      title: "Member Name",
      dataIndex: ["name", "email"],
      key: "memberName",
      render: (_, data) => {
        return (
          <div
            style={{
              //   width: "250px",
              display: "flex",
              marginRight: "0px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Text
                style={{
                  fontStyle: "normal",
                  fontWeight: "bold",
                  fontSize: "14px",
                  lineHeight: "24px",
                  color: "#181818",
                  // whiteSpace: "nowrap",
                  //   overflow: "scroll",
                }}
              >
                Gautham Reddy
                {/* {data.name ? data.name : "Gautham Reddy"} */}
              </Text>
              <Text>
                {data.email ? data.email : "bill.sanders@example.com"}
              </Text>
            </div>
          </div>
        );
      },
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "region",
      render: (data) => {
        var role = Roles[(Math.random() * Roles.length) | 0];
        return (
          <div
            style={
              {
                //   width: "150px"
              }
            }
          >
            <Tag
              className={data ? data : role}
              style={{
                whiteSpace: "nowrap",
              }}
            >
              {data ? data : role}
            </Tag>
          </div>
        );
      },
    },
    {
      title: "Activity",
      dataIndex: "activity",
      key: "activity",
      render: (data) => {
        return (
          <Text
            style={{
              marginLeft: "14px",
              fontStyle: "normal",
              //   fontWeight: `${Status ? "700" : "normal"}`,
              fontSize: "14px",
              lineHeight: "22px",
              color: "#464646",
            }}
          >
            Store Created
          </Text>
        );
      },
    },
    {
      title: "Activity On",
      dataIndex: "activity-on",
      key: "activity-on",
      render: (data) => {
        return (
          <div
            style={
              {
                //   width: "150px"
              }
            }
          >
            <Text
              style={{
                whiteSpace: "nowrap",
              }}
            >
              {data ? data : "24/04/2021 05:00 pm "}
            </Text>
          </div>
        );
      },
    },

    {
      title: "",
      dataIndex: ["uuid", "name", "status"],
      key: "uuid",
      render: (_, row) => {
        // console.log(row);
        return (
          <div style={{ width: "16px" }}>
            {/* <Dropdown
              placement={"bottomLeft"}
              onClick={(e) => {
                e.stopPropagation();
              }}
              width={30}
              style={{ marginLeft: "0", width: "30px", height: "40px" }}
              overlay={
                <Menu>
                  <Menu.Item
                    onClick={(e) => {
                      e.domEvent.stopPropagation();
                      setUpdateModal(true);
                    }}
                  >
                    <Text style={{ color: "#181818" }}>Edit Premissons</Text>
                  </Menu.Item>

                  <Menu.Item
                    onClick={(e) => {
                      e.domEvent.stopPropagation();
                      setDeleteModal(true);
                    }}
                  >
                    <Text style={{ color: "#C91713" }}>Delete</Text>
                  </Menu.Item>
                </Menu>
              }
            > */}

            <Icon
              type="right"
              onClick={(e) => {
                e.stopPropagation();
                setStoreCreatedModal(true);
              }}
              style={{
                width: "30px",
                fontSize: "14px",
                color: "#747474",
                marginLeft: "52px",
              }}
            />
            {/* </Dropdown> */}
          </div>
        );
      },
    },
  ];
  return (
    <>
      <Table
        // rowSelection={props.noAction ? null : rowSelection}
        columns={columns}
        dataSource={data.stores}
        pagination={{ showQuickJumper: true, pageSize: data.pageSize }}
        style={{ overflow: "none" }}
        // onChange={(pagination) => {
        //   props.updatePage(pagination.current);
        // }}
        loading={props.loading}
      />

      <Modal
        centered
        visible={storeCreatedModal}
        destroyOnClose
        maskClosable={false}
        onCancel={() => setStoreCreatedModal(false)}
        footer={null}
        width={900}
      >
        {/* <StoreAddModal data={data} /> */}
        {/* <CohortAddModal data={data} {...props} /> */}
        <ReportModal data={data} {...props} />
      </Modal>
    </>
  );
};
export default ActivityManagment;
